// React
import { useEffect } from "react"

// Functions
import { toast } from "functions"

// Third-Party Library
import { useLocation, useNavigate } from "react-router-dom"

// Components
import { PaymentSection, Td, TdEnd } from "components"

const OrderReview = () => {
  // Hooks
  const navigate = useNavigate()
  const { state } = useLocation()

  useEffect(() => {
    if (!state) {
      toast("error", "Error", "No booking data available")
      navigate(-1)
    }

    window.scrollTo(0, 0)
    // eslint-disable-next-line
  }, [])

  if (!state) {
    return null
  } else {
    // Variables
    const totalPrice = state.ticket.reduce(
      (previousValue, { pax, price }) => previousValue + (parseInt(pax || 0) * price), 0
    )
    const tax = totalPrice * 0.17

    return (
      <PaymentSection state={state} totalPrice={totalPrice} tax={tax}>
        {state.ticket.filter(val => parseInt(val.pax) > 0).map((val, index) => (
          <tr key={index}>
            <Td>
              <div className="d-flex justify-center-start align-items-center">
                <img height={60} className="me-2" alt="Product" src={val.image} />
                <div className="fw-bold">{val.pax}x {val.name}</div>
              </div>
            </Td>
            <Td>
              <TdEnd>IDR {(val.price * parseInt(val.pax)).toLocaleString('id-ID')}</TdEnd>
            </Td>
          </tr>
        ))}
      </PaymentSection>
    )
  }
}

export default OrderReview